import { Component } from '@angular/core';

@Component({
  selector: 'app-about-schneiderei',
  templateUrl: './about-schneiderei.component.html',
  styleUrls: ['./about-schneiderei.component.less'],
})
export class AboutSchneidereiComponent {

}
